import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { FISCAL_DOCUMENTS } from "@/utils/fiscalDocuments.js";
import { deliverFiscalDocument } from "@/utils/deliverFiscalDocument.js";

/**
 * Recuadro para entregar un documento fiscal desde la ficha del emisor. El tipo
 * decide la ruta y el texto; lo que pasa después de soltar el archivo —el aviso
 * del paquete, el semáforo de la 32/D— es común a todas las formas de subirlo.
 */
const FiscalDocumentUpload = ({
  companyId,
  type = "fiscalCertificate",
  onUploadSuccess,
}) => {
  const { t } = useTranslation();
  const { titleKey } = FISCAL_DOCUMENTS[type];

  const onDrop = useCallback(
    async (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      const delivered = await deliverFiscalDocument({
        companyId,
        type,
        file: acceptedFiles[0],
      });

      if (delivered) onUploadSuccess?.();
    },
    [companyId, type, onUploadSuccess],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      className="dropzone mb-3"
      style={{
        border: "2px dashed #ccc",
        padding: "20px",
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>{t("ui.dropHere")}</p>
      ) : (
        <p>{t("ui.uploadNew", { document: t(titleKey) })}</p>
      )}
    </div>
  );
};

export default FiscalDocumentUpload;
